import config from "config";
import React from "react";

export const ErrorContactUs = () => {
	return (<>
		Something went wrong on our side 😥. If the problem remains, please contact us &ensp;
		<a className="text-decoration-underline text-white" href={`mailto:${config.EMAIL_CONTACT}`}>here</a>
	</>);
}